export function serializeObjectToQueryParameter (object) {
  var parameters = []
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) {
      parameters.push(encodeURIComponent(p) + '=' + encodeURIComponent(object[p]))
    }
  }
  return '?' + parameters.join('&')
}
